import { FormFieldDef, InputType } from '../../../interfaces/form-config.interface';

export type SegmentField = { kind: 'field'; field: FormFieldDef };
export type SegmentGroup = { kind: 'group'; name: string; fields: FormFieldDef[] };
export type Segment = SegmentField | SegmentGroup;

export function toSegments(fields: FormFieldDef[]): Segment[] {
  const segments: Segment[] = [];
  for (const field of fields) {
    if (!field.group) {
      segments.push({ kind: 'field', field });
    } else {
      const last = segments[segments.length - 1];
      if (last?.kind === 'group' && last.name === field.group) {
        last.fields.push(field);
      } else {
        segments.push({ kind: 'group', name: field.group, fields: [field] });
      }
    }
  }
  return segments;
}

export function flattenSegments(segments: Segment[]): FormFieldDef[] {
  const out: FormFieldDef[] = [];
  for (const seg of segments) {
    if (seg.kind === 'field') out.push(seg.field);
    else out.push(...seg.fields);
  }
  out.forEach((f, i) => { f.order = i + 1; });
  return out;
}

export const OPTION_BASED = new Set<string>([
  InputType.DROPDOWN,
  InputType.MULTI_DROPDOWN,
  InputType.SELECTABLE_PILL,
  InputType.MULTI_SELECTABLE_PILL,
  InputType.DYNAMIC_CHECK_TEXTBOX,
]);

export const DEFAULT_LOCALES = ['en', 'zh-Hant'];

export const ALL_INPUT_TYPES = Object.values(InputType);
